import React, { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { audio } from "../lib/audio";

export default function MusicToggle({ className }) {
  const [, force] = useState(0);
  useEffect(() => audio.subscribe(() => force((v) => v + 1)), []);
  const muted = audio.isMuted();
  const playing = audio.isPlaying();
  const onToggle = () => { const nowMuted = audio.toggleMute(); if (!nowMuted) audio.playWelcome(); };

  const pos = className || "fixed bottom-20 right-4 sm:bottom-6 sm:right-6 z-[90]";
  return (
    <button
      onClick={onToggle}
      data-testid="music-toggle"
      aria-label={muted ? "Unmute music" : "Mute music"}
      className={`${pos} h-11 w-11 rounded-full flex items-center justify-center bg-white/80 dark:bg-black/50 backdrop-blur-md border border-black/5 shadow-lg tap transition-transform active:scale-90`}
    >
      {muted ? (
        <VolumeX className="h-5 w-5 text-muted-foreground" />
      ) : (
        <span className="relative flex items-center justify-center">
          <Volume2 className="h-5 w-5 text-primary" />
          {playing && (
            <span className="absolute -right-2 -bottom-1 flex items-end gap-[1.5px] h-2.5">
              {[0, 1, 2].map((i) => (
                <span key={i} className="w-[2px] bg-primary rounded-full eq-bar" style={{ animationDelay: `${i * 0.15}s` }} />
              ))}
            </span>
          )}
        </span>
      )}
    </button>
  );
}
